import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, Grid } from '@mui/material';
// Import Date Picker components
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs'; // Import dayjs

const RequestFilter = ({
    geometries = [],
    selectedGeometryId = 'all',
    onGeometryChange,
    loading = false,
    disabled = false,
    startDate = null,
    endDate = null,
    onDateChange
}) => {

    const handleGeomChange = (event) => {
        if (onGeometryChange) {
            onGeometryChange(event.target.value);
        }
    };

    // Handler for date changes
    const handleDateChange = (type, newValue) => {
        if (onDateChange) {
            onDateChange(type, newValue);
        }
    };

    const hasGeometries = !loading && geometries && geometries.length > 0;

    return (
        // Wrap everything in LocalizationProvider for date pickers
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* Use Grid for layout - Removed flexWrap="nowrap" */}
            <Grid container spacing={2} alignItems="center">
                {/* Geometry Filter - Takes full width */}
                <Grid item xs={12}>
                    <FormControl fullWidth disabled={disabled || loading || !hasGeometries} size="small">
                        <InputLabel id="geometry-filter-label">Filter by Geometry</InputLabel>
                        <Select
                            labelId="geometry-filter-label"
                            id="geometry-filter-select"
                            value={selectedGeometryId}
                            label="Filter by Geometry"
                            onChange={handleGeomChange}
                        >
                            <MenuItem value="all">
                                <em>All Geometries</em>
                            </MenuItem>

                            {loading ? (
                                <MenuItem disabled>
                                    <Typography variant="caption" color="textSecondary">Loading...</Typography>
                                </MenuItem>
                            ) : hasGeometries ? (
                                geometries.map((geom) => (
                                    // Assuming geom object has 'id' and 'name'
                                    // Use geom_id if that's the correct key from your data
                                    <MenuItem key={geom.id || geom.geom_id} value={geom.id || geom.geom_id}>
                                        {geom.name || `Geometry ${geom.id || geom.geom_id}`}
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>
                                    <Typography variant="caption" color="textSecondary">No geometries</Typography>
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Start Date Picker - Takes half width */}
                <Grid item xs={3}>
                    <DatePicker
                        label="Start Date"
                        value={startDate}
                        onChange={(newValue) => handleDateChange('start', newValue)}
                        disabled={disabled}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                        maxDate={endDate}
                    />
                </Grid>

                {/* End Date Picker - Takes half width */}
                <Grid item xs={3}>
                    <DatePicker
                        label="End Date"
                        value={endDate}
                        onChange={(newValue) => handleDateChange('end', newValue)}
                        disabled={disabled}
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                        minDate={startDate}
                    />
                </Grid>
            </Grid>
        </LocalizationProvider>
    );
};

export default RequestFilter;
